<div class="row" *ngIf="!showFallbackView">
  <div class="col-sm-12">
    <div class="row top-exposure-section">
      <div class="col-4 col-sm-4" *ngFor="let topExposure of topExposures; let i = index;">
        <top-exposure-item [platformList]="platformList"
                           [exposureType]="getExposureType(i)"
                           [topExposure]="topExposure">
        </top-exposure-item>
      </div>
    </div>
  </div>
</div>
<div class="placeholder-container" *ngIf="showFallbackView">
  <top-exposure-placeholder></top-exposure-placeholder>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposures/top-exposures.component.html